var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".x-image.x-image-error[data-v-66142e88],.x-image.x-image-loading[data-v-66142e88]{background-image:url(" + escape(require("@/assets/images/codemao_preview.png")) + ")}.x-image-bgimg[data-v-66142e88]{background-color:#f5f5f5;background-repeat:no-repeat,no-repeat;background-position:50%,50%}.x-image-img[data-v-66142e88]{background-color:#f5f5f5;background-position:50%;background-repeat:no-repeat}", ""]);

// exports
